module.exports = __webpack_public_path__ + "img/default.d2241a0e.svg";